import { formValueSelector } from 'redux-form';

import { INFERENTIAL_STATISTICS } from '../../names';
import { RAW_DATA } from 'scenes/InferentialStatistics/Constants';

const selector = formValueSelector(INFERENTIAL_STATISTICS);

const makeFieldValueGetter = field =>
  state => selector(state, field);

export const getNumberOfGroups =
  makeFieldValueGetter('anova.numbersOfGroups');

export const getAnovaGroups =
  makeFieldValueGetter('anova.groups');

export const getNumericalRowAnova =
  makeFieldValueGetter('anova.numericalRowDataSetAnova');

export const getCategoricalRowAnova =
  makeFieldValueGetter('anova.categoricalRowDataSetAnova');

export const getAnovaDatasetContains =
  makeFieldValueGetter('anova.datasetContains');

export const isAnovaModeDatasetContainsRawData = state =>
  getAnovaDatasetContains(state) === RAW_DATA;

export const isNumericalAndCategoricalAnovaChosen = state => {
  return !!getNumericalRowAnova(state) && !!getCategoricalRowAnova(state);
};
